import _ from 'lodash';
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { filter, map } from 'rxjs/operators';
import { ImportImageService } from '../../services/import-images.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-import-images',
  templateUrl: './import-images.component.html',
  styleUrls: ['./import-images.component.scss']
})
export class ImportImagesComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public import: UntypedFormControl = null;

  public images: any[] = [];
  public imageUrls: number = 0;
  public localImages: number = 0;
  public missed: any[] = []
  public files: any[] = [];

  @Input()
  public options: UntypedFormArray = new UntypedFormArray([], []);

  @Input()
  public disabled: boolean = false;

  @Output()
  public onChange: EventEmitter<any> = new EventEmitter();

  @Output()
  public onChangeFiles: EventEmitter<any> = new EventEmitter();

  @Output()
  public onChangeMissed: EventEmitter<any> = new EventEmitter();

  public extensions: string[] = [];
  public types: string[] = ['^image/.*$'];

  public errors: string[] = [];
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    private importImageService: ImportImageService
  ) { 
    this.import = this.formBuilder.control(null, []);
  }

  ngOnInit(): void {
    this.import.valueChanges.pipe(
      filter(value => !_.isNull(value)),
      map(value => _.isArray(value) ? value: [value]),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((files) => {
      this.updateImages();
      this.updateFiles(files);
      this.updateMissed();

      this.onChangeCallback();
    });

    this.updateImages();
    this.updateFiles([]);

    this.onChangeCallback();
  }

  updateImages() {
    this.images = this.importImageService.getImages(this.options);
    this.imageUrls = this.importImageService.getImageUrls(this.images);
    this.localImages = this.importImageService.getLocalImages(this.images);
  }

  updateFiles(files) {
    this.files = _.chain(files).filter(file => {
      const index = _.findIndex(this.images, {
        name: _.trim(file.name)
      });
      if(index >= 0) {
        const image = this.images[index];
        image.found = true;
        return true;
      }
      return false;
    }).map(file => {
      return {
        file,
        uploaded: false,
        error: null
      }
    }).value();

    this.onChangeFiles.next(this.files);
  }

  updateMissed() {
    this.missed = _.filter(this.images, (image) => {
      if(image.name === "/images/blank_2x1.png") {
        return false;
      }
      try {
        new URL(image.name);
        return false;
      } catch(e) {
        return !image.found;
      }
    });

    this.onChangeMissed.next(this.missed);
  }

  removeImage({ name }: File) {
    this.updateImages();
    _.remove(this.files, ({ file }) => _.isEqual(file.name, name));
    const files = _.map(this.files, ({ file }) => file);
    this.updateFiles(files);
    this.updateMissed();

    this.onChangeCallback();
  }

  getFileSize({ size }: File) {
    const kbs = Math.floor(size / 1024);
    return `${kbs} kb`;
  }

  onSelect(file: File) {
    this.files.push({ file, uploaded: false, error: null});

    this.onChangeCallback();
  }

  onChangeCallback() {
    const images = _.chain(this.images).filter(image => {
      try {
        new URL(image.name);
        return true;
      } catch(e) {
        return false;
      }
    }).map(image => {
      return {
        url: image.name,
        uploaded: false,
        error: null
      }
    }).concat(this.files).value();

    this.onChange.next(images);
  }

}
